<!-- Wrapper Body -->
<div class="wrapper" *ngIf="show">
<div class="wrapper-body pt-md-0 pl-md-0">
<div class="background-form">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-3 p-0">
                <div class="client-info p-5">
                    <img src="assets/images/logo.png" alt="Diagnostic Learning Services Logo" width="150"
                        class="img-fluid mb-5">
                    <h4 class="text-grey">Client Observation</h4>
                    <hr>
                    <div class="detail">
                        <ul>
                            <li>
                                <label>Name</label>
                                <p>{{apptDetails.parentDetails.studentFirstName}} {{apptDetails.parentDetails.studentLastName}}</p>
                            </li>
                            <li>
                                <label>Determination</label>
                                <p>{{apptDetails.parentDetails.schoolType}}</p>
                            </li>
                            <li>
                                <label>Type of Test</label>
                                <p>{{apptDetails.appointmentDetails.assesmentType}}</p>
                            </li>
                            <li>
                                <label>Appointment Date/Time</label>
                                <p>{{apptDetails.appointmentDetails.schedules[0].appointmentDate}} (CST)</p>
                            </li>
                            <li>
                                <label>Location</label>
                                <p>{{apptDetails.appointmentDetails.location}}</p>
                            </li>
                            <li>
                                <label>Diagnostician</label>
                                <p>{{apptDetails.appointmentDetails.diagnosticianName}}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-9 px-0">
                <div class="d-flex my-3">
                    <a href="javascript:Void(0)" data-target="#viewDocumentsModal" data-toggle="modal" class="ml-auto ml-2 theme-button green">View Documents</a>
                    <a [routerLink]="['/appt-all-details',apptDetails.appointmentDetails.appointmentId]" class="grey ml-3 theme-button">Back</a>
                </div>
                <div id="studentObservationForm" class="custom-form">
                    <div class="row">
                        <!-- Survey Detail -->
                        <div class="col-md-6">
                            <div class="card">
                                <h5 class="mb-0 text-purple">Surveys Performed</h5>
                                <hr>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex flex-wrap"
                                            *ngIf="apptDetails.appointmentDetails.schedules[0].assesmentSurvey.length>0">
                                            <p class="badge badge-pill bg-purple-light mr-2  px-3 py-2"
                                                *ngFor="let survey of apptDetails.appointmentDetails.schedules[0].assesmentSurvey">
                                                {{survey.name}}</p>
                                        </div>
                                        <div class="d-flex flex-wrap"
                                            *ngIf="apptDetails.appointmentDetails.schedules[0].assesmentSurvey.length==0">
                                            <p class="text-warning mr-2  px-3 py-2">
                                                No Survey Selected</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Test Detial -->
                        <div class="col-md-6">
                            <div class="card">
                                <h5 class="mb-0 text-purple">Tests Performed</h5>
                                <hr>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex flex-wrap"
                                            *ngIf="apptDetails.appointmentDetails.schedules[0].assesmentTest.length>0">
                                            <p class="badge badge-pill bg-purple-light mr-2 px-3 py-2"
                                                *ngFor="let test of apptDetails.appointmentDetails.schedules[0].assesmentTest">
                                                {{test.name}}
                                            </p>
                                        </div>
                                        <div class="d-flex flex-wrap"
                                            *ngIf="apptDetails.appointmentDetails.schedules[0].assesmentTest.length==0">
                                            <p class="text-warning mr-2  px-3 py-2">
                                                No Tests Selected</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Student Observation Form -->
                        <div class="col-12">
                            <div class="card">
                                <h5 class="mb-0 text-purple">Observation Form</h5>
                                <hr>

                                <div>
                                    <div class="row pt-1 px-3">
                                        <div class="col-lg-3 col-md-6 pt-2">
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.bouncingLeg==true"
                                                        type="checkbox" class="custom-control-input">
                                                    <label class="custom-control-label" for="bouncingLeg">Bouncing
                                                        leg</label>
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.tappingPencil==true"
                                                        type="checkbox" class="custom-control-input">
                                                    <label class="custom-control-label" for="tapping-pencil">Tapping
                                                        pencil</label>
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.playingWithPencil==true"
                                                        type="checkbox" class="custom-control-input">
                                                    <label class="custom-control-label"
                                                        for="playing-with-pencil">Playing with
                                                        pencil</label>
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.pickingIPad==true"
                                                        type="checkbox" class="custom-control-input">
                                                    <label class="custom-control-label" for="picking-iPad">Picking at
                                                        iPad</label>
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.UpPermission==true"
                                                        type="checkbox" class="custom-control-input">
                                                    <label class="custom-control-label" for="Up-permission">Up w/o
                                                        permission</label>
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.difficultySitting==true"
                                                        type="checkbox" class="custom-control-input">
                                                    <label class="custom-control-label"
                                                        for="difficulty-sitting">Difficulty
                                                        sitting</label>
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.chewingClothing==true"
                                                        type="checkbox" class="custom-control-input">
                                                    <label class="custom-control-label" for="chewing-clothing">Chewing
                                                        on
                                                        clothing</label>
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.playingWithHair==true"
                                                        type="checkbox" class="custom-control-input">
                                                    <label class="custom-control-label" for="playing-with-hair">Playing
                                                        with
                                                        hair</label>
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.playingWithJewelry==true"
                                                        type="checkbox" class="custom-control-input">
                                                    <label class="custom-control-label"
                                                        for="playing-with-jewelry">Playing with
                                                        jewelry</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-6 pt-2">
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.shufflingFeet==true"
                                                        type="checkbox" class="custom-control-input">
                                                    <label class="custom-control-label" for="shuffling-feet">Shuffling
                                                        feet</label>
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.noisesWithMouth==true"
                                                        type="checkbox" class="custom-control-input">
                                                    <label class="custom-control-label" for="noises-with-mouth">Noises
                                                        with
                                                        mouth</label>
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.humming==true" type="checkbox"
                                                        class="custom-control-input">
                                                    <label class="custom-control-label" for="humming">Humming</label>
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.clickingOfTongue==true"
                                                        type="checkbox" class="custom-control-input">
                                                    <label class="custom-control-label"
                                                        for="clicking-of-tongue">Clicking of
                                                        tongue</label>
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.impulsiveResponses==true"
                                                        type="checkbox" class="custom-control-input">
                                                    <label class="custom-control-label"
                                                        for="impulsive-responses">Impulsive
                                                        responses</label>
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.excessiveTalking==true"
                                                        type="checkbox" class="custom-control-input">
                                                    <label class="custom-control-label"
                                                        for="excessive-talking">Excessive
                                                        Talking</label>
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.rushesThroughTasks==true"
                                                        type="checkbox" class="custom-control-input">
                                                    <label class="custom-control-label"
                                                        for="rushes-through-tasks">Rushes
                                                        through
                                                        tasks</label>
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.playingWithClothes==true"
                                                        type="checkbox" class="custom-control-input">
                                                    <label class="custom-control-label"
                                                        for="playing-with-clothes">Playing with
                                                        clothes</label>
                                                </div>
                                            </div>
                                            <div class="mb-2">
                                                <div class="custom-control custom-checkbox">
                                                    <input [attr.disabled]=true
                                                        [checked]="studentObservationTest.needsFrequentRedirect==true"
                                                        type="checkbox" class="custom-control-input"
                                                        value="Needs frequent redirect">
                                                    <label class="custom-control-label"
                                                        for="needs-frequent-redirect">Needs
                                                        frequent
                                                        redirect</label>
                                                </div>
                                            </div>
                                        </div>

                                        <!--  -->

                                        <div class="col-lg-6 px-0">
                                            <div class="rounded bg-theme-light px-3 pt-2">
                                                <div class="d-flex border-bottom justify-content-between">
                                                    <small class="py-1 mr-3">Adequate pencil grasp?</small>
                                                    <div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input [attr.disabled]="true"
                                                                [checked]="studentObservation.pencilGrasp==1"
                                                                type="radio" id="adequate-pencil-yes"
                                                                class="custom-control-input">
                                                            <label class="custom-control-label"
                                                                for="adequate-pencil-yes">Yes</label>
                                                        </div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input type="radio" [attr.disabled]="true"
                                                                [checked]="studentObservation.pencilGrasp==2"
                                                                id="adequate-pencil-yes" class="custom-control-input">
                                                            <label class="custom-control-label"
                                                                for="adequate-pencil-no">No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex border-bottom justify-content-between">
                                                    <small class="py-1 mr-3">Holds paper with other hand when
                                                        writing?</small>
                                                    <div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input [attr.disabled]="true"
                                                                [checked]="studentObservation.holdsPaper==1"
                                                                type="radio" id="holds-paper-yes"
                                                                class="custom-control-input">
                                                            <label class="custom-control-label"
                                                                for="holds-paper-yes">Yes</label>
                                                        </div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input [attr.disabled]="true"
                                                                [checked]="studentObservation.holdsPaper==2"
                                                                type="radio" id="holds-paper-yes"
                                                                class="custom-control-input">
                                                            <label class="custom-control-label"
                                                                for="holds-paper-no">No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex border-bottom justify-content-between">
                                                    <small class="py-1 mr-3">More than one snack break?</small>
                                                    <div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input [attr.disabled]="true"
                                                                [checked]="studentObservation.moreSnackBreak==1"
                                                                type="radio" id="more-snac-break-yes"
                                                                class="custom-control-input">
                                                            <label class="custom-control-label"
                                                                for="more-snac-break-yes">Yes</label>
                                                        </div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input [attr.disabled]="true"
                                                                [checked]="studentObservation.moreSnackBreak==2"
                                                                type="radio" id="more-snac-break-no"
                                                                class="custom-control-input">
                                                            <label class="custom-control-label"
                                                                for="more-snac-break-no">No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex border-bottom justify-content-between">
                                                    <small class="py-1 mr-3">More than one bathroom break?</small>
                                                    <div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input [attr.disabled]="true"
                                                                [checked]="studentObservation.moreBathroomBreak==1"
                                                                type="radio" id="more-bathroom-break-yes"
                                                                class="custom-control-input">
                                                            <label class="custom-control-label"
                                                                for="more-bathroom-break-yes">Yes</label>
                                                        </div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input [attr.disabled]="true"
                                                                [checked]="studentObservation.moreBathroomBreak==2"
                                                                type="radio" id="more-bathroom-break-no"
                                                                class="custom-control-input">
                                                            <label class="custom-control-label"
                                                                for="more-bathroom-break-no">No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex border-bottom justify-content-between">
                                                    <small class="py-1 mr-3">Frequently responded with IDK</small>
                                                    <div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input [attr.disabled]="true"
                                                                [checked]="studentObservation.idk==1" type="radio"
                                                                id="idk-yes" class="custom-control-input">
                                                            <label class="custom-control-label"
                                                                for="idk-yes">Yes</label>
                                                        </div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input [attr.disabled]="true"
                                                                [checked]="studentObservation.idk==2" type="radio"
                                                                id="idk-no" class="custom-control-input">
                                                            <label class="custom-control-label" for="idk-no">No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex border-bottom justify-content-between">
                                                    <small class="py-1 mr-3">Gives up easily</small>
                                                    <div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input [attr.disabled]="true"
                                                                [checked]="studentObservation.giveUp==1" type="radio"
                                                                class="custom-control-input">
                                                            <label class="custom-control-label"
                                                                for="give-up-yes">Yes</label>
                                                        </div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input [attr.disabled]="true"
                                                                [checked]="studentObservation.giveUp==2" type="radio"
                                                                class="custom-control-input">
                                                            <label class="custom-control-label"
                                                                for="give-up-no">No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex border-bottom justify-content-between">
                                                    <small class="py-1 mr-3">How much longer?</small>
                                                    <div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input [attr.disabled]="true"
                                                                [checked]="studentObservation.howMuchLongerTally==1"
                                                                type="radio" class="custom-control-input">
                                                            <label class="custom-control-label"
                                                                for="how-much-longer-pencil-yes">Yes</label>
                                                        </div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input [attr.disabled]="true"
                                                                [checked]="studentObservation.howMuchLongerTally==2"
                                                                type="radio" class="custom-control-input">
                                                            <label class="custom-control-label"
                                                                for="how-much-longer-pencil-no">No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex border-bottom justify-content-between">
                                                    <small class="py-1 mr-3">Needs directions repeated</small>
                                                    <div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input [attr.disabled]="true"
                                                                [checked]="studentObservation.needsDirection==1"
                                                                type="radio" class="custom-control-input">
                                                            <label class="custom-control-label"
                                                                for="needs-direction-yes">Yes</label>
                                                        </div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input [attr.disabled]="true"
                                                                [checked]="studentObservation.needsDirection==2"
                                                                type="radio" class="custom-control-input">
                                                            <label class="custom-control-label"
                                                                for="needs-direction-no">No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex border-bottom justify-content-between">
                                                    <small class="py-1 mr-3">Glasses?</small>
                                                    <div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input [attr.disabled]="true"
                                                                [checked]="studentObservation.glasses==1" type="radio"
                                                                class="custom-control-input">
                                                            <label class="custom-control-label"
                                                                for="glasses-yes">Yes</label>
                                                        </div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                            <input [attr.disabled]="true"
                                                                [checked]="studentObservation.glasses==2" type="radio"
                                                                class="custom-control-input">
                                                            <label class="custom-control-label"
                                                                for="glasses-no">No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


             <!-- Your Observation Form -->
             <div class="col-12">
                <div class="card">
                    <h5 class="mb-0 text-purple">Observation Summary</h5>
                    <hr>
                    <form form="observationSummary" class="custom-form">
                        <div id="observation" class="rounded bg-theme-light py-3">
                            <div class="col-12">
                                <label for="answer1">Observation added by Diagnostician</label>
                                <textarea [attr.disabled]="true" name="answer1" rows="5" readonly>{{observationForm.comments}}</textarea>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

                        <!-- Student Information Form -->
                        <div class="col-12">
                            <div class="card">
                                <h5 class="mb-0 text-purple">Student Information Form</h5>
                                <hr>
                                <form class="custom-form">
                                    <div id="observation" class="rounded bg-theme-light py-3">
                                        <div class="col-12">
                                            <label for="answer1">What are your feelings toward school and
                                                learning?</label>
                                            <textarea [attr.disabled]="true" rows="2">{{observationForm.studentInfo.answer1}}</textarea>
                                        </div>
                                        <div class="col-12">
                                            <label for="answer2">What is your easiest subject and why?</label>
                                            <textarea [attr.disabled]="true" rows="2">{{observationForm.studentInfo.answer2}}</textarea>
                                        </div>
                                        <div class="col-12">
                                            <label for="answer3">What is your least favourite subject and why?</label>
                                            <textarea [attr.disabled]="true" rows="2">{{observationForm.studentInfo.answer3}}</textarea>
                                        </div>
                                        <div class="col-12">
                                            <label for="answer4">Which skills are hardest for you or what do you
                                                struggle with
                                                the
                                                most in school?</label>
                                            <textarea [attr.disabled]="true" rows="2">{{observationForm.studentInfo.answer4}}</textarea>
                                        </div>
                                        <div class="col-12">
                                            <label for="answer5">If you struggle in school, how does that make you
                                                feel?</label>
                                            <textarea [attr.disabled]="true" rows="2">{{observationForm.studentInfo.answer5}}</textarea>
                                        </div>
                                        <div class="col-12">
                                            <label for="answer6">What would help you feel more comfortable and
                                                successful in
                                                school?</label>
                                            <textarea [attr.disabled]="true" rows="2">{{observationForm.studentInfo.answer6}}</textarea>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
</div>

<div class="modal fade" id="viewDocumentsModal" data-keyboard="true" tabindex="-1"
aria-labelledby="viewDocumentsModal" aria-hidden="true">
<div class="modal-dialog">
    <div class="modal-content light px-5 py-4">
        <div class="d-flex justify-content-end">
            <!-- Close button or icon -->
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <h5 class="text-center mb-4">Attached Documents</h5>
        <div class="d-flex flex-wrap justify-content-center">
            <p class="badge bg-theme-light border mr-2" *ngFor="let doc of documents">
                <a [href]="appBaseUrl + doc.filePath" download="{{doc.fileName}}" target="_blank" class="d-block px-3 py-2 small text-dark">&#10515; Download {{doc.fileName}}</a>
            </p>
        </div>
    </div>
</div>
</div>


<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple">
    <!-- <p style="color: white">Please Wait... </p> -->
</ngx-spinner>
